<template>
  <div v-show="isOpen" class="uploads__list unfinished-uploads__list">
    <button class="button hide" @click="onHideClicked">
      <i class="fa fa-times" aria-hidden="true" />
    </button>
    <h3 class="unfinished-uploads__title">Unfinished uploads list</h3>
    <p class="unfinished-uploads__info">
      You have unfinished uploads.
      Probably, your browser was crashed or you're closed the page during file uploading.
      Please, select file to continue upload or remove them from the list.
    </p>
    <template v-if="unfinishedUploads.length">
      <ListItem
        v-for="unfinishedItem in unfinishedUploads"
        :key="unfinishedItem.id"
        :filename="unfinishedItem.filename"
        :accepted-files="unfinishedItem.uploadParams.acceptedFiles || ''"
        @file-selected="onFileSelected($event, unfinishedItem)"
        @remove-clicked="onRemoveClicked($event, unfinishedItem.id)"
      />
    </template>
    <p v-else class="unfinished-uploads__resolved">All unfinished uploads are resolved.</p>
  </div>
</template>

<script>
import ListItem from './ListItem';

export default {
  name: 'UnfinishedUploadsList',

  components: {
    ListItem,
  },

  props: {
    unfinishedUploads: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    onHideClicked() {
      this.$emit('hide');
    },
    onFileSelected(file, item) {
      this.$emit('file-selected', {
        ...item,
        files: [file],
      });
    },
    onRemoveClicked(event, id) {
      this.$emit('remove-clicked', id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// UnfinishedList.vue?979eac44